/* constants */
import custas, {obterAtosComCodigo, obterAtoSeloVinculado, obterSeloAtoVinculador} from '@/constants/custas'
// Utils
import { stringToNumber, matriculaTransforma, iniciaisSolicitante } from '@/utils/conversors'
import { verificaImpressos } from './papelSeguranca'
// Services
import SelosService from "@/services/Registros/SelosService"
import { ConsomePapel } from './papelSeguranca'

// Retorno
let selosList = []
let papelConsumido
let itemOsIdComErroGerarSelo = []
let MsgErrorVinculacoes
let vinculacoesComErro = []

// Uso interno
let novoSelo
let papelCusta


export async function CriarSelo (ordemServico, papelConsumo, cartorioObj, tipoRegistro) {

  const itensOs = ordemServico.itens
  let errosVinculacao = ''
  let tipo_registro = null

  for (const item of itensOs) {
    const index = itensOs.indexOf(item)
    if (!item.seloStatus && (!item.custa.codigo || !item.custa.tipoAtoSelo)) continue
    if (!!item.seloItemOs) continue

    if (!!tipoRegistro) {
      tipo_registro = tipoRegistro
    }

    for (let i = 0; i < item.quantidade; i++ ) {
      const atos = obterAtosComCodigo(item.custa.codigo, tipo_registro)

      let seloDuplo = []
      
      for (const ato of atos) {
        papelCusta = papelConsumo.find(custa => custa.index == index)
        if (papelCusta) papelCusta.papeldaVez = i

        // Monta payload a ser enviado para o server
        const payload = handlerSeloPayload(ordemServico, item, ato, cartorioObj)

        try {
          loader({ text: 'Gerando o(s) selo(s)...', active: true })
          novoSelo = await SelosService.storeSelo(payload)
          if (!novoSelo) return itemOsIdComErroGerarSelo.push(item.ordem_servico_item_id)
          selosList.push(novoSelo)
          seloDuplo.push(novoSelo)

          if (item.impressosSeguranca && !!papelCusta && !obterSeloAtoVinculador().includes(ato)) {
            papelConsumido = await ConsomePapel(papelCusta, item, i)
          }

          if (ordemServico.uf_cartorio === 'SP' && ordemServico.num_selo) await VincularSeloSP(ordemServico)
          if (ordemServico.uf_cartorio === 'OUTRO') await VincularSeloOutros(payload)
         } catch (error) {
          loader({ text: '', active: false })
          itemOsIdComErroGerarSelo.push(item.ordem_servico_item_id)
          continue
        }

      }
      if (atos.length === 2 && seloDuplo.length === 2) {
        errosVinculacao = await VincularSeloDuplo(seloDuplo)
      }
    }
  }
  if (errosVinculacao) {
      await displayMessage('error', 'Erro', errosVinculacao)
  }
  loader({ text: '', active: false })
  return {
    selosList,
    papelConsumido,
    itemOsIdComErroGerarSelo,
    MsgErrorVinculacoes,
    vinculacoesComErro
  }
}

export async function VincularSeloSP (ordemServico) {
  loader({ text: 'Aguarde vinculações de selo...', active: true })

  const vinculacoes = []
  vinculacoes.push(ordemServico.num_selo)

    const payloadVinculacao = {
      numSeloVinculador: novoSelo.num_selo,
      vinculacoes,
      realizarEnvioVinculacaoTJ: true
    }
  try {
    const { vinculacoes } = await SelosService.vincularSelos(payloadVinculacao)
    vinculacoesComErro = vinculacoes.vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)

    if (!!vinculacoesComErro) {
      MsgErrorVinculacoes = vinculacoesComErro.length === 1 ? 'Ocorreu erro com alguma vinculação. ' : 'Ocorreu erro com algumas vinculações. '
      MsgErrorVinculacoes += 'Para verificar localize a data da vinculações na lista de selos vinculados e clique em editar para mais informações.'
      await displayMessage('error', '', MsgErrorVinculacoes)
    }
  } catch (error ) {

  } finally {
    loader({ text: '', active: false })
  }
}

export async function VincularSeloOutros (payload) {
  loader({ text: 'Aguarde vinculações de selo...', active: true })
  const vinculacoes = []
    payload.ato = 'XX'
  try {
    const segundoSelo = await SelosService.gerarSeloVinculado(payload)
    vinculacoes.push(segundoSelo.num_selo)
  } catch (error) {
    MsgErrorVinculacoes = 'Erro ao criar selo para vinculação - Pedido CRC'
    await displayMessage('error', 'Error', MsgErrorVinculacoes )
    loader({ text: '', active: false })
    return
  }

    const payloadVinculacao = {
      numSeloVinculador: novoSelo.num_selo,
      vinculacoes,
      realizarEnvioVinculacaoTJ: true
    }

    try {
      const { vinculacoes } = await SelosService.vincularSelos(payloadVinculacao)
      const vinculacoesComErro = vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)

      let texto = 'Vinculação realizada com sucesso!'

      if (vinculacoesComErro.length) {
        texto = vinculacoesComErro.length === 1 ? 'Ocorreu erro com alguma vinculação. ' : 'Ocorreu erro com algumas vinculações. '
        texto += 'Para verificar localize a data da vinculações na lista de selos vinculados e clique em editar para mais informações.'
      }
      await displayMessage('success', 'Success', texto)
    } catch (error) {
      // const message = getErrors(error)
      let texto = vinculacoesComErro.length === 1 ? 'Ocorreu erro com alguma vinculação. ' : 'Ocorreu erro com algumas vinculações. '
      texto += 'Para verificar localize a data da vinculações na lista de selos vinculados e clique em editar para mais informações.'
      await displayMessage('error', 'Error', texto)
    } finally {
      loader({ text: '', active: false })
    }

}

export async function VincularSeloDuplo (ordemServico) {

  const seloVinculador = ordemServico.find(item => obterSeloAtoVinculador().includes(item.tipo_ato))
  const seloVinculado = ordemServico.find(item => obterAtoSeloVinculado().includes(item.tipo_ato))
  const vinculacoes = []
  let texto = ''

  if (!seloVinculador || !seloVinculador.num_selo || !seloVinculado || !seloVinculado.num_selo) {
    return 'Ocorreu erro com a vinculação dos selos. Ato de selagem dupla não encontrado. Contate o suporte'
  }

  vinculacoes.push(seloVinculado.num_selo)

  const payloadVinculacao = {
    numSeloVinculador: seloVinculador.num_selo,
    vinculacoes,
    realizarEnvioVinculacaoTJ: true
  }

  try {
    loader({ text: 'Vinculando selos duplos...', active: true })
    const { vinculacoes } = await SelosService.vincularSelos(payloadVinculacao)
    const vinculacoesComErro = vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)

    if (vinculacoesComErro.length) {
      texto = 'Ocorreu erro com a vinculação dos selos'
    }
  } catch (error ) {
    texto = 'Ocorreu erro com a vinculação dos selos'
  } finally {
    if (texto) return texto
    loader({ text: '', active: false })
  }
}

function handlerSeloPayload (ordemServico, item, ato, cartorioObj) {
  const payload = {
    ordem_servico_item_id: item.ordem_servico_item_id,
    cpf: process.env.NODE_ENV === 'production' ? ordemServico.cpf_solicitante : '40300169876', // hmlg > CPF VENDRA "40300169876"
    natureza: item.custa.tipo === 'ATOS_NOTARIAIS' ? 1 : 2,
    ato: ato,
    cns: process.env.NODE_ENV === 'production' ? cartorioObj.cns : '115204', //  hmlg > CNS VENDRA 115204
    iniciais_solicitante: iniciaisSolicitante(ordemServico.nome_solicitante),
    valor_vinculado: ordemServico.valor_da_custa ? stringToNumber(ordemServico.valor_da_custa) : 0,
    cpf_solicitante: ordemServico.cpf_solicitante,
    num_matricula: ordemServico.num_matricula_registro ? matriculaTransforma(ordemServico.num_matricula_registro) : null,
    cartorio: cartorioObj,
    papel_custa: papelCusta || null,
    tipo_selo: custas.selosFisicos.indexOf(ato) != -1 ? 'Fisico' : 'Digital',
    registro_id: ordemServico.registro_id || null
  }

  return payload
}

export function seloValidate (custa) {
  // Disable selo box
  let permiteSelo = false
  let requiredSelo = false
  let checkImpresso = false
  let permiteImpressao = false

  if (!custa.codigo || custa.codigo === 12) return {permiteSelo}
    permiteSelo = true
    permiteImpressao = verificaImpressos(custa.codigo)
    
    const atos = obterAtosComCodigo(custa.codigo)
    for (const ato of atos) {
      const verify = custas.selosFisicos.includes(ato)
      if (verify) {
        requiredSelo = true
        if (permiteImpressao) checkImpresso = true        
      }
    }    
  return {permiteSelo, requiredSelo, checkImpresso, permiteImpressao}   
}
